(function(){
function init(){
document.querySelectorAll('[data-oa-cg]').forEach(function(root){
if (root._oaCGInit) return;
root._oaCGInit = true;
/* Filter tabs */
var btns = root.querySelectorAll('[data-oa-cg-filter]');
btns.forEach(function(btn){
btn.addEventListener('click',function(){
btns.forEach(function(b){b.classList.remove('is-active')});
btn.classList.add('is-active');
var handle = btn.getAttribute('data-oa-cg-filter');
root.querySelectorAll('[data-oa-cg-grid]').forEach(function(g){
g.style.display = g.getAttribute('data-oa-cg-grid') === handle ? '' : 'none';
});
});
});
/* i18n globaal uit App Embed (Translate & Adapt) */
var i18n = {};
var i18nScript = document.getElementById('oa-modules-i18n') || root.querySelector('[data-oa-cg-i18n]');
if (i18nScript) { try { i18n = JSON.parse(i18nScript.textContent || '{}'); } catch(e) {} }
/* Quick add to cart (hover overlay) */
root.querySelectorAll('[data-oa-cg-add]').forEach(function(btn){
btn.addEventListener('click',function(e){
e.preventDefault();
e.stopPropagation();
var vid = btn.getAttribute('data-variant-id');
if(!vid) return;
var span = btn.querySelector('span');
var origText = span ? span.textContent : (i18n.add_to_cart || 'Toevoegen');
btn.disabled = true;
if(span) span.textContent = i18n.loading || 'Laden...';
fetch('/cart/add.js',{
method:'POST',
headers:{'Content-Type':'application/json'},
body:JSON.stringify({items:[{id:parseInt(vid),quantity:1}]})
}).then(function(r){ return r.json(); }).then(function(data){
if(span) span.textContent = i18n.added || 'Toegevoegd!';
var variant = Array.isArray(data.items) ? data.items[0] : data;
var popdown = document.querySelector('[data-product-add-popdown-wrapper]');
if(popdown){
popdown.dispatchEvent(new CustomEvent('theme:cart:popdown',{detail:{variant:variant},bubbles:true}));
}
setTimeout(function(){ btn.disabled=false; if(span) span.textContent=origText; },1500);
}).catch(function(){
if(span) span.textContent = i18n.error || 'Fout';
setTimeout(function(){ btn.disabled=false; if(span) span.textContent=origText; },1500);
});
});
});
/* Wishlist hart toggle — gebruikt dezelfde localStorage (oaWishlist, object-format) als
   oa-wishlist-app.js en oa-product-block.js, zodat de favorieten-popup en badge meedoen. */
var WISH_KEY = 'oaWishlist';
function getWishList(){ try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch(e){ return []; } }
function setWishList(list){
  localStorage.setItem(WISH_KEY, JSON.stringify(list));
  var detail = { count: list.length, list: list };
  window.dispatchEvent(new CustomEvent('oa-wishlist:changed', { detail: detail }));
  document.dispatchEvent(new CustomEvent('oa-wishlist:changed', { detail: detail }));
}
function syncWishButtons(){
  var list = getWishList();
  root.querySelectorAll('[data-oa-cg-wish]').forEach(function(btn){
    var handle = btn.getAttribute('data-oa-cg-wish');
    var active = list.some(function(x){ return x.handle === handle; });
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
}
root.querySelectorAll('[data-oa-cg-wish]').forEach(function(btn){
  var handle = btn.getAttribute('data-oa-cg-wish');
  if(!handle) return;
  btn.addEventListener('click',function(e){
    e.preventDefault(); e.stopPropagation();
    var list = getWishList();
    if(list.some(function(x){ return x.handle === handle; })){
      setWishList(list.filter(function(x){ return x.handle !== handle; }));
    } else {
      var item = {
        handle: handle,
        title: btn.getAttribute('data-oa-cg-wish-title') || handle,
        url: btn.getAttribute('data-oa-cg-wish-url') || ('/products/' + handle),
        image: btn.getAttribute('data-oa-cg-wish-image') || null,
        addedAt: Date.now()
      };
      setWishList([item].concat(list));
    }
    syncWishButtons();
  });
});
syncWishButtons();
/* Live mee-veranderen als ergens anders (PDP, popup) gewijzigd wordt */
window.addEventListener('oa-wishlist:changed', syncWishButtons);
window.addEventListener('storage', function(e){ if(e.key === WISH_KEY) syncWishButtons(); });
/* Veeg-peek (alleen touch): toon de 2e foto onder de vinger tijdens vegen.
   Een pure tik beweegt niet en zet dus geen --peek -> het product opent gewoon. */
(function(){
  if(!('ontouchstart' in window)) return;
  var peeked = null;
  function clearPeek(){ if(peeked){ peeked.classList.remove('oa-cg__card--peek'); peeked = null; } }
  function onMove(e){
    var t = e.touches && e.touches[0];
    if(!t) return;
    var el = document.elementFromPoint(t.clientX, t.clientY);
    var card = (el && el.closest) ? el.closest('.oa-cg__card') : null;
    if(card === peeked) return;
    clearPeek();
    if(card && root.contains(card)){
      card.classList.add('oa-cg__card--peek');
      peeked = card;
    }
  }
  root.addEventListener('touchmove', onMove, { passive: true });
  root.addEventListener('touchend', clearPeek, { passive: true });
  root.addEventListener('touchcancel', clearPeek, { passive: true });
})();
});
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
document.addEventListener('shopify:section:load',init);
})();
